<template>
<div class="chapter">
<div class="inner_page">
<div class="_idGenObjectStyleOverride-1" epub:type="toc" id="_idContainer000">
<p class="ORIM-Body-Text-No-Indent-SpB4--Body- ParaOverride-9" lang="en-US">ALSO BY ROBERT GOLDSBOROUGH </p>
<p class="ORIM-Body-Text-No-Indent-SpB4--Body- ParaOverride-9" lang="en-US"><u>The Nero Wolfe
					Mysteries</u>
</p>
<p class="ORIM-Body-Text-No-Indent- ParaOverride-9" lang="en-US"><span class="ORIM-ital"><i>Murder in E Minor</i></span></p>
<p class="ORIM-Body-Text-No-Indent- ParaOverride-9" lang="en-US"><span class="ORIM-ital"><i>Death
						on Deadline</i></span></p>
<p class="ORIM-Body-Text-No-Indent- ParaOverride-9" lang="en-US"><span class="ORIM-ital"><i>Fade
						to Black</i></span></p>
<p class="ORIM-Body-Text-No-Indent- ParaOverride-9" lang="en-US"><span class="ORIM-ital"><i>The
						Bloodied Ivy</i></span></p>
<p class="ORIM-Body-Text-No-Indent- ParaOverride-9" lang="en-US"><span class="ORIM-ital"><i>The
						Last Coincidence</i></span></p>
<p class="ORIM-Body-Text-No-Indent- ParaOverride-9" lang="en-US"><span class="ORIM-ital"><i>Silver Spire</i></span></p>
<p class="ORIM-Body-Text-No-Indent- ParaOverride-9" lang="en-US"><span class="ORIM-ital"><i>The
						Missing Chapter</i></span></p>
<p class="ORIM-Body-Text-No-Indent- ParaOverride-9" lang="en-US"><span class="ORIM-ital"><i>Archie Meets Nero Wolfe</i></span></p>
<p class="ORIM-Body-Text-No-Indent- ParaOverride-9" lang="en-US"><span class="ORIM-ital"><i>Murder in the Ball Park</i></span></p>
<p class="ORIM-Body-Text-No-Indent- ParaOverride-9" lang="en-US"><span class="ORIM-ital"><i>Archie in the Crosshairs</i></span></p>
<p class="ORIM-Body-Text-No-Indent- ParaOverride-9" lang="en-US"><span class="ORIM-ital"><i>Stop
						the Presses!</i></span></p>
<p class="ORIM-Body-Text-No-Indent- ParaOverride-9" lang="en-US"><span class="ORIM-ital"><i>Murder, Stage Left</i></span></p>
<p class="ORIM-Body-Text-No-Indent- ParaOverride-9" lang="en-US"><span class="ORIM-ital"><i>The
						Battered Badge</i></span></p>
<p class="ORIM-Body-Text-No-Indent- ParaOverride-9" lang="en-US"><span class="ORIM-ital"><i>Death
						of an Art Collector</i></span></p>
<p class="ORIM-Body-Text-No-Indent- ParaOverride-9" lang="en-US"><span class="ORIM-ital"><i>Archie Goes Home</i></span></p>
<p class="ORIM-Body-Text-No-Indent- ParaOverride-9" lang="en-US"><span class="ORIM-ital"><i>Trouble at the Brownstone</i></span></p>
<p class="ORIM-Body-Text-No-Indent-SpB4--Body- ParaOverride-9" lang="en-US"><u>The Snap Malek
					Mysteries</u></p>
<p class="ORIM-Body-Text-No-Indent- ParaOverride-9" lang="en-US"><span class="ORIM-ital"><i>Three
						Strikes You’re Dead</i></span></p>
<p class="ORIM-Body-Text-No-Indent- ParaOverride-9" lang="en-US"><span class="ORIM-ital"><i>Shadow of the Bomb</i></span></p>
<p class="ORIM-Body-Text-No-Indent- ParaOverride-9" lang="en-US"><span class="ORIM-ital"><i>A
						Death in Pilsen</i></span></p>
<p class="ORIM-Body-Text-No-Indent- ParaOverride-9" lang="en-US"><span class="ORIM-ital"><i>A
						President in Peril</i></span></p>
<p class="ORIM-Body-Text-No-Indent- ParaOverride-9" lang="en-US"><span class="ORIM-ital"><i>Terror at the Fair</i></span></p>
<p class="ORIM-Body-Text-No-Indent- ParaOverride-9" lang="en-US"><span class="ORIM-ital"><i>Stairway to Nowhere &amp; Other Stories</i></span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// MissingHeiress.vue?9cee011a